<template>
	<div>

		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<button class="btn btn-light" style="position: absolute; right: 0.5em; top: 0.5em;" @click.prevent="refreshObject"><i class="fas fa-sync-alt"></i> Refresh</button>
				<h4 class="my-0 font-weight-normal"><template v-if="unaugmented">Edit</template><template v-else>Augment</template> Data Object</h4>
			</div>
			<div class="card-body px-3">

				<div class="form-check mb-3" v-if="!isStorageCollection( )">
					<input type="checkbox" v-model="unaugmented" class="form-check-input" id="display_unaugmented" checked>
					<label class="form-check-label" for="display_unaugmented">Bypass Augmentation <small class="text-muted">(view/edit raw source object <u>without</u> augmentations applied)</small></label>
				</div>

				<!-- <div class="container p-0" style="padding-right: 50px !important;">
					<object-editor-id :item="objectEditorData.$id" :key="rawObject.$id" :disabled="true"></object-editor-id>
					<object-editor-schema :key="rawObject.$schema" :item="objectEditorData.$schema" :schemas="schemas"></object-editor-schema>
					<object-editor-item v-for="( field, index ) in objectEditorData.fields" :key="field._htmlId" :schemas="schemas" :item="field" :index="index" :source="objectEditorData.fields" :html-id="field._htmlId" :augment="!unaugmented"></object-editor-item>
					<button v-if="!mySchemaItem.value" @click.prevent="addEditorField( objectEditorData.fields, !unaugmented )" class="btn btn-info mt-1">Add Field to Object</button>
				</div> -->

				<object-editor-item-root :key="objectEditorData._htmlId" :schemas="schemas" :item="objectEditorData" :augment="!unaugmented" :allowed-schemas="allowedSchemas"></object-editor-item-root>

				<hr class="mb-2">
				<div class="form-group mb-0 mt-0">
					<button class="btn btn-success mt-2" @click.prevent="saveUIEditorObject"><i class="fas fa-save"></i> Save Object</button>
					<!-- <button class="btn btn-secondary mt-2" @click.prevent="setEditorObject( )"><i class="fas fa-sync-alt"></i> Reset Editor</button> -->
					<button class="btn btn-danger float-right mt-2 ml-1" @click.prevent="deleteThisObject"><i class="fas fa-times"></i> Delete Object</button>
				</div>

				<div class="form-group mb-0 mt-0">
					<button class="btn btn-secondary mt-2" @click.prevent="_showEditorData">Show Editor Data</button>
					<button class="btn btn-secondary mt-2" @click.prevent="_showObjectUpdates">Show Object Updates</button>
					<button class="btn btn-secondary mt-2" @click.prevent="_showSchemas">Show Schemas</button>
				</div>

			</div>
			
		</div>

		<div class="card shadow-sm">
			<div class="card-header">
				<button class="btn btn-light" style="position: absolute; right: 0.5em; top: 0.5em;" @click.prevent="refreshObject"><i class="fas fa-sync-alt"></i> Refresh</button>
				<h4 class="my-0 font-weight-normal">Edit Data Object (JSON)</h4>
			</div>
			<div class="card-body">

				<div id="editor"></div>
				<button class="btn btn-success mt-4" @click.prevent="saveJSONEditorObject"><i class="fas fa-save"></i> Save Object</button>
				<!-- <button class="btn btn-secondary mt-4" @click.prevent="setJSONEditorObject( )"><i class="fas fa-sync-alt"></i> Reset Editor</button> -->

			</div>
		</div>

	</div>
</template>

<script>
import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import mixinObjectEditing from "@/components/mixins/objectEditing.js";
import ObjectEditorItemRoot from "@/components/utilities/ObjectEditorItemRoot";

import _ from 'lodash';
import { randomString } from '../util';
import { EventBus } from '@/eventBus';

import WNValidator from '@/temp-validation/WNValidator';

const REGEX_AUG_INDEX_ACCESS = /^\\\$(0|[1-9]\d*)$/;
const REGEX_SOURCE_INDEX_ACCESS = /^\$(0|[1-9]\d*)$/;

export default {
	name: "data-object",
	props: [ 'nodeId', 'projectId', 'collectionName', 'objectId' ],
	mixins: [
		mixinObjectEditing
	],
	components: {
		// ObjectEditorItem,
		// ObjectEditorId,
		// ObjectEditorSchema,
		ObjectEditorItemRoot,
	},
	data() {
		return {
			augmentation : null,
			unaugmented: false,
			rawObject: { },	// Important. Needs to start out empty object.
			objectUpdates: { },
			refreshingObject: 0,
			objectEditorData: {
				type : "object",
				$id : { type : "auto" },
				$schema : { type : "none" },
				fields : [ ]
			},
			schemas: {
				raw : [ ],
				compiled : { }
			},
		};
	},
	watch:
	{
		objectEditorData:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				//console.log( "Editor Data:", JSON.stringify( newValue, null, 2 ) );
				this.updateObjectDataFromEditor( );
			},
		},
		objectUpdates:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				const updates = this.createUpdateInstructions( this.rawObject, newValue, !this.unaugmented );
				this.editor.setValue( JSON.stringify( updates, null, 2 ), -1 );
			}
		},
		unaugmented: function( newValue, oldValue )
		{
			//this.refreshObject( );
		}
	},
	computed:
	{
		// mySchemaItem( )
		// {
		// 	return ( this.objectEditorData && typeof this.objectEditorData === 'object' ? this.objectEditorData.$schema || { } : { } );
		// },
		...mapGetters( "collections", {
			collection: "collection", // map STATE collections/collections to "collections" AS A FUNCTION, which requires the nodeId, projectId and collectionName as inputs!
		}),
		// ...mapGetters( "augmentations", {
		// 	augmentation: "augmentation", // map STATE augmentations/augmentation to "augmentations" AS A FUNCTION, which requires the nodeId, projectId and collectionName as inputs!
		// }),
		currentAug( )
		{
			return this.augmentation || null;	// this.augmentation( this.nodeId, this.projectId, this.collectionName, this.objectId );	// If no aug: null
		},
		allowedSchemas( )
		{
			try {
				if( this.myCollection.schemas && typeof this.myCollection.schemas === 'object' )
				{
					const schemas = [];
					for( let name in this.myCollection.schemas )
						if( this.myCollection.schemas[name].allow )
							schemas.push( name );
					return schemas;collection
				}
			} catch( err ) { }
			return;
		},
		myCollection( )
		{
			return this.collection( this.nodeId, this.projectId, this.collectionName );
		},
	},
	methods:
	{
		schemaName( id )
		{
			return id.substring( id.indexOf( ':' ) + 1 );
		},
		_showEditorData( )
		{
			console.log( JSON.stringify( this.objectEditorData, null, 2 ) );
		},
		_showObjectUpdates( )
		{
			console.log( JSON.stringify( this.objectUpdates, null, 2 ) );
		},
		_showSchemas( )
		{
			console.log( Object.keys( this.schemas.compiled ), this.allowedSchemas );
		},
		isStorageCollection( )
		{
			if( !this.myCollection )
			{
				console.warn( `My Collection [${this.collectionName}] Not Found!` );
				return true;
			}
			else
				return this.myCollection.$schema.indexOf('.reference.') < 0;
		},
		updateObjectDataFromEditor: function( )
		{
			this.objectUpdates = _.omit( this.editorDataToObject( this.objectEditorData, !this.unaugmented ), [ '$id' ] );
		},
		async refreshObject( )
		{
			this.refreshingObject++;
			
			EventBus.$emit( "modal", {
				type: "loading",
				title: "Data Object",
				message: "Please wait until we load the data object and any related schemas."
			});
			
			// Retrieve augmentation; it will be stored in the store getter, accessible here by "this.currentAug"
			if( !this.isStorageCollection( ) )	// Only look for augmentation when this is NOT a storage collection.
				try {
					this.augmentation = await this.readAug( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, objectId : this.objectId, nocache : true } );
				} catch( err ) { console.log( "ERROR:", err.message ); }
			
			let object = await this.readObject( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, objectId : this.objectId, options : { unaugmented : true }, nocache : true } );
			//this.rawObject = object;

			// if( !this.unaugmented )	// If we're retrieving the augmented version:
			// 	object = await this.readObject( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, objectId : this.objectId, nocache : true } );
			
			try {
				const fields = this.objectEditorData.fields;
				for( let i=fields.length-1; i >= 0; i-- )
					this.$delete( fields, i );
				this.$set( this.objectEditorData.$schema, 'type', 'none' );
			} catch( err ) { }
			
			const augmentation = ( this.unaugmented ? undefined : ( this.currentAug || undefined ) );

			this.$nextTick( ( ( ) =>
			{
				this.objectEditorData = this.objectToEditorData( object, this.schemas.compiled || { }, augmentation );
				this.objectEditorData._htmlId = randomString( );
				this.rawObject = object;	// Needs to happen after, to make sure $id and $schema keys are updated only after editor data is created.

				this.refreshingObject--;

				if( !object )
				{
					EventBus.$emit( "modal", {
						type: "error",
						title: "Data Object Not Found",
						message: "This object was not found; please check the ID."
					});
				}
				else if( this.refreshingObject < 1 )
					EventBus.$emit( "modal", { type: "close" });

			} ).bind(this) );
			
			// this.setEditorObject( object );
			// TODO: End Loading
		},
		async deleteThisObject( )
		{
			if( !confirm( "Are you sure you want to delete this object?" ) )
				return;
			try {
				let result = await this.deleteObject( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, objectId : this.objectId } );
				if( !result )
					console.warn( "[DataObject] Object was not found at deletion! Redirecting to Objects listing anyway." );
				this.$router.push( { name : 'objects', params : { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName } } );
			} catch( err ) {
				console.error( err );
				alert( "Object could not be deleted!\n"+ err.message );
			}
		},
		getObject( )
		{
			return this.$store.getters['objects/object']( this.nodeId, this.projectId, this.collectionName, this.objectId );
		},
		setEditorObject( object, augmentation )
		{
			object = object || this.getObject( ) || { };
			if( !this.unaugmented )
				augmentation = augmentation || this.currentAug || undefined;
			else
				augmentation = undefined;

			//console.log( "EDITOR OBJECT:", JSON.stringify( object, null, 2 ) );
			this.objectEditorData = this.objectToEditorData( object, this.schemas.compiled || { }, augmentation );
			//console.log( "EDITING DATA:", JSON.stringify( this.objectEditorData, null, 2 ) );
		},
		setJSONEditorObject( object )
		{
			//console.warn( "USING SET JSON METHOD..." );
			object = object || this.getObject( );
			//console.log( "JSON OBJECT:", JSON.stringify( object, null, 2 ) );
			if( object && this.editor )
			{
				let editorObject = _.omit( object, [ '$created', '$modified', '$version', '$node', '$id' ] );
				//console.log( "JSON OBJECT:", JSON.stringify( editorObject, null, 2 ) );
				this.editor.setValue( JSON.stringify( editorObject, null, 2 ), -1 );
			}

		},
		async saveJSONEditorObject( )
		{
			let data;

			try {
				data = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Could not save the JSON data:\n"+ err.message );
				console.error( err );
				return;
			}

			await this._saveObject( data, true );	// Save as ready-to-go instructions (hence the "asInstructions" [true] flag.).
		},
		async saveUIEditorObject( )
		{
			await this._saveObject( this.objectUpdates );
		},

		_isRealObjectValue( value )
		{
			switch( typeof value )
			{
				case "number":
				case "string":
				case "boolean":
					return false;
				case "object":
					if( null === value )
						return false;
					if( Array.isArray( value ) )
						return false;
					let keys = Object.keys( value );
					if( keys.length === 1 && keys[0] === '$date' )
						return false;
					if( value.hasOwnProperty( '$ref' ) )
						return false;
					return true;
				case "undefined":
					if( allowUndefined )
						return false;
			}
			throw new Error( "Invalid value found (type: "+ typeof value +"): "+ value );
		},

		createUpdateInstructions( originalValue, updatedObject, augmentation = false, _nested = false )
		{
			const opPrefix = ( augmentation ? "\\$" : "$" );
			const instructions = { };

			const REGEX_INDEX_ACCESS = ( augmentation ? REGEX_AUG_INDEX_ACCESS : REGEX_SOURCE_INDEX_ACCESS );

			let wholeIndexReplace;
			if( Array.isArray( originalValue ) )
			{
				for( let f in updatedObject )
				{
					const itemIndexReplace = REGEX_INDEX_ACCESS.test( f );
					if( wholeIndexReplace != itemIndexReplace && typeof wholeIndexReplace !== 'undefined' )
						throw new Error( "Found inconsistent array-index-update augmentation: "+ JSON.stringify( updateObject ) );
					wholeIndexReplace = itemIndexReplace;
				}
			}

			let originalObject;
			if( originalValue && this._isRealObjectValue( originalValue ) )
				originalObject = _.clone( originalValue );
			else
			{
				// In all cases (even augmentation), when original value is not an object, we add $new (or \$new for augs).
				if( typeof originalValue !== 'undefined' && !updatedObject["\\$delete"] && !wholeIndexReplace )
					instructions[opPrefix +'new'] = true;
				
				// Advanced usage note: augmentations safely ignore non-$new object updates when they are applied to non-object values.
				//		Users can manually delete the $new prop when they want to take advantage of that conditional augmentation mechanic.
				// TODO: The storage engine should also IGNORE non-$new object updates over non-object values (currently it FAILS the entire update)

				originalObject = { };
			}

			// Process changes to all fields that exist in the original object.
			for( let f in updatedObject )
			{
				if( f === '' || typeof updatedObject[f] === 'undefined' )
					continue;	// Just in case we have an empty field or an explicitly set own property [undefined], ignore as if DNE.
				
				if( REGEX_INDEX_ACCESS.test( f ) )	// Fudge value of array if successful index access.
				{
					const updateIndex = parseInt( f.split( '$' )[1] );
					if( Array.isArray( originalValue ) && originalValue.length > updatedObject )
						originalObject[f] = originalValue[updateIndex];
						// Note: we can fudge originalObject[f] now; since it will be deleted at the end of this interation.
				}
				else if( f.startsWith( "$" ) )
				{
					switch( f )
					{
						case "$id":		// Allow nested $id fields..
						case "$schema":	// Allow updating of $schema
						case "$new":	// Allow explicit $new in updatedObject
						case "\\$new":	// Allow explicit \$new in augmentation
							break;
						default:
							console.log( "Skipping system field ["+ f +"] to create replacement instructions. Only [$schema] updates allowed for now." );
							continue;
					}
				}

				if( !this._isRealObjectValue( updatedObject[f] ) )
				{
					if( augmentation || !_.isEqual( originalObject[f], updatedObject[f] ) )
						instructions[f] = _.clone( updatedObject[f] );
				}
				else	// updatedObject[f] IS AN OBJECT VALUE
				{
					instructions[f] = this.createUpdateInstructions( originalObject[f], updatedObject[f], augmentation, true );
					if( _.isEqual( instructions[f], { } ) )
					 	delete instructions[f];
				}

				delete originalObject[f];	// In case we made no updates, we must remove this entry, so that it doesn't trigger a $delete in the next step. It's cloned.
			}
			
			// ONLY IN SOURCE OBJECT EDITING, delete all fields that existed originally, but were not included in the update object.
			if( !augmentation )
				for( let f in originalObject )
					if( !instructions.hasOwnProperty( f ) && ( !f.startsWith( '$' ) || f === '$schema' || ( f === '$id' && _nested ) ) )
						instructions[f] = { $delete : true };	// Delete the field, including possibly [$schema]
			
			return instructions;
		},

		async _saveObject( updates, asInstructions = false )
		{
			// TODO: Set loading overlay
			
			let options = { unaugmented : ( this.unaugmented ? true : undefined ) };

			if( !asInstructions )
			{
				updates = _.omit( updates, [ '$created', '$modified', '$version', '$node', '$id' ] );
				updates = this.createUpdateInstructions( this.rawObject, updates, !this.unaugmented );
			}
			
			//console.log( "UPDATE INSTRUCTIONS:", JSON.stringify( updates, null, 2 ) );
			
			try {
				if( this.unaugmented )
				{
					//console.log( "RAW OBJECT UPDATES:", JSON.stringify( updates, null, 2 ) );
					let result = await this.updateObject( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, objectId : this.objectId, updates, options } );
					if( null === result )
						throw new Error( "This object is no longer found in the repository!" );
				}
				else
				{
					updates.$id = this.objectId;
					let result;
					//console.log( "NEW AUGMENTATION:", JSON.stringify( updates, null, 2 ) );
					try {
						result = await this.replaceAug( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, newAugmentation : updates } );
					} catch( err ) { console.warn( "Augmentation replacement failed: "+ err.message ); }
				}
				this.refreshObject( );
				// this.setEditorObject( );
				// this.setJSONEditorObject( );
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				let message = err.message;
				if( err.response && err.response.data && err.response.data.$error )
					message = err.response.data.$error.message;

				alert( "Object Update Failed:\n"+ message );
				//console.warn( "Object save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				//this.$router.push( { name : 'objects', params : { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName } } );
			}
		},
		...mapActions({
			listSchemas: "schemas/list",
			readSchema: "schemas/read",
			readObject: "objects/read",
			updateObject: "objects/update",
			deleteObject: "objects/delete",
			deleteAug: "augmentations/delete",
			createAug: "augmentations/create",
			replaceAug: "augmentations/replace",
			readAug: "augmentations/read",
		}),
	},
	async created( )
	{
	},
	async mounted( )
	{
		EventBus.$emit( "modal", {
			type: "loading",
			title: "Data Object",
			message: "Please wait until we load the data object and any related schemas."
		});

		this.editor = ace.edit( "editor", {
			mode: "ace/mode/json",
			theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
			maxLines: 20,
			minLines: 5,
			fontSize: 14,
			showPrintMargin : false
		});

		const isStorage = this.isStorageCollection( );
		this.unaugmented = isStorage;	// In case of !isStorage, then this is just a default.
		
		this.$set( this.schemas, 'raw', await this.listSchemas( { nodeId : this.nodeId, projectId : this.projectId, nocache : !isStorage, options : { contextcollection : this.collectionName } } ) );
		const validator = new WNValidator( { schemas: this.schemas.raw } );

		const compiledSchemas = validator.getCompiledSchemas( { lookup: true } );
		for( let name in compiledSchemas )
		{
			const schema = compiledSchemas[name];
			schema.fieldsLookup = { };
			for( const field of schema.compiledfields )
				schema.fieldsLookup[field.name] = field;
		}
		// for( let i=0; i < this.schemas.raw.length; i++ )
		// {
		// 	const name = this.schemaName( this.schemas.raw[i].$id );
		// 	const options = { compiled : true, contextcollection : this.collectionName };
		// 	const compiledSchema = await this.readSchema( { nodeId : this.nodeId, projectId : this.projectId, name, options, nocache : true } );
		// 	compiledSchema.fieldsLookup = { };
		// 	for( let i=0; i < compiledSchema.compiledfields.length; i++ )
		// 	{
		// 		const field = compiledSchema.compiledfields[i];
		// 		compiledSchema.fieldsLookup[field.name] = field;
		// 	}
		// 	compiledSchemas[name] = compiledSchema;
		// }
		this.$set( this.schemas, 'compiled', compiledSchemas );
		// console.log( "SCHEMAS (NEW)", this.schemas.compiled );

		await this.refreshObject( );
		// Temporarily, we just run refresh twice in succession.
		// There is some race condition which fails to load augs sometimes..
		await this.refreshObject( );
	}
};
</script>
<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/DataObject.vue